<template>
  <div class="sub-layers">
    <div class="layer slide-layer">
      <button class="drag-handle tb-btn tb-btn-link sm low-em" :data-test="`graphics-editor-layer-rearrange-${element.id}`" title="Rearrange"><span class="fas fa-grip-vertical"></span></button>

      <button class="tb-btn tb-btn-link sm low-em group-arrow" :data-test="`graphics-editor-layer-collapseToggle-${element.id}`" v-on:click.stop="toggleCollapsed">
        <span class="fas" :class="getGroupArrowClass"></span>
      </button>

      <div class="layer-name ml-1" v-if="!editing" :data-test="`graphics-editor-layer-title-${element.id}`" v-on:dblclick="showEditing">{{entry.meta.name}}</div>
      <form v-if="editing" v-on:submit.prevent="hideEditing">
        <input type="text" v-on:keyup.stop class="tb-input" :data-test="`graphics-editor-layer-title-${element.id}`" v-model="entry.meta.name">
        <button type="submit" class="hidden"></button>
      </form>

      <div v-if="!editing" class="layer-actions ml-1">
        <button class="tb-btn tb-btn-link sm low-em layer-visibility" :data-test="`graphics-editor-layer-visibility-${element.id}`" v-on:click.stop="toggleVisible">
          <span class="fas" :class="[entry.meta.visible ? 'fa-eye' : 'fa-eye-slash']"></span>
        </button>
        <button class="tb-btn tb-btn-link sm low-em remove-layer" :data-test="`graphics-editor-layer-remove-${element.id}`" v-on:click.stop="removeSlide">
          <span class="fas fa-trash"></span>
        </button>
      </div>

    </div>

    <div v-if="showAlert" class="confirm text-center">
      <button class="tb-btn tb-btn-text sm medium-em" data-test="graphics-editor-alert-cancelButton" v-on:click="showAlert = false">Cancel</button>
      <button class="tb-btn tb-btn-contained sm high-em" data-test="graphics-editor-alert-confirmButton" v-on:click="removeConfirm">Delete slide</button>
    </div>

    <div class="sub-layers" v-if="!entry.meta.collapsed">
      <div class="layer-wrapper" :key="element.id" v-for="element in entry.fields">
        <layer :selected="selected" v-on:select="select" :graphic_field="element" v-model="element.visible" :element="element"></layer>

        <div class="sub-layers">
          <layers
            v-if="element.type === 'group' && !element.collapsed"
            :selected="selected"
            :graphic_fields="graphic_fields"
            :sub_elements="element.entries"
            @select="select"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LayerComponent from '../layers/Layer.vue';
import LayersComponent from '../layers/Layers.vue';

export default {
  props: ['selected', 'graphic_fields', 'element', 'entry', 'index', 'sub_elements'],
  data() {
    return {
      showAlert: false,
      editing: false,
    };
  },
  components: {
    layer: LayerComponent,
    layers: LayersComponent,
  },
  computed: {
    getGroupArrowClass() {
      return this.entry.meta.collapsed ? 'fa-caret-right' : 'fa-caret-down';
    },
  },
  methods: {
    select(element) {
      if (element.type !== 'group') {
        this.$emit('select', element);
      }
    },
    check(evt) {
      if (!this.$el.contains(evt.target)) {
        this.hideEditing();
      }
    },
    showEditing() {
      this.editing = true;
      document.body.addEventListener('click', this.check);
    },
    hideEditing() {
      this.editing = false;
      document.body.removeEventListener('click', this.check);
    },
    toggleCollapsed() {
      this.entry.meta.collapsed = !this.entry.meta.collapsed;
    },
    toggleVisible() {
      this.entry.meta.visible = !this.entry.meta.visible;
    },
    removeSlide() {
      this.showAlert = true;
    },
    removeConfirm() {
      const entries = this.graphic_fields[this.element.id]?.entries;
      if (!entries) {
        this.graphic_fields[this.element.id].entries = [];
      }

      this.graphic_fields[this.element.id].entries.splice(this.index, 1);
      this.showAlert = false;
    },
  },
  beforeUnmount() {
    document.body.removeEventListener('click', this.check);
  },
};
</script>
